<template>
   <div class="table-responsive">
      <table class="table table-condensed table-striped">
         <thead>
            <th v-for="(col, index) in headers" :key="index">
               <span>
                  {{ col.label }}
               </span>
               <span v-if="col.sortable">
                  <i class=""></i>
               </span>
            </th>
         </thead>
         <tbody v-if="hasData()">
            <tr v-for="(row, indx) in records" :key="indx">
               <td v-for="(col, index) in headers" :key="'0-' + index" v-tooltip:Left="toolTipText(col)">
                  <span v-if="col.name == '__ACTION'" @click.prevent="clickHandler(row)">
                     <i class="fas fa-arrow-circle-right ml-corp pointer" role="button"></i>
                  </span>
                  <span v-if="col.name == '__HIER'" @click.prevent="clickHierarchy(row)">
                     <i class="fi-interface-organization ml-corp pointer" role="button"></i>
                  </span>
                  <span v-else>
                     <span v-if="col.isdate == true">
                        {{ row[col.name] | shortDate }}
                     </span>
                     <span v-else>
                        {{ row[col.name] }}
                     </span>
                  </span>
               </td>
            </tr>
         </tbody>
         <tbody v-else>
            <td :colspan="headers.length" class="not-found">
               {{ noDataMsg }}
            </td>
         </tbody>
         <tfoot v-show="showFooter">
            <td :colspan="headers.length">
               <div class="float-right">
                  Records Per Page:
                  <select class="rpp-btn" v-model="recordsPerPage" v-on:change="pageSizeChanged">
                     <option value="10">10</option>
                     <option value="50">50</option>
                  </select>
               </div>
               <div class="text-left">
                  <button type="button" class="page-btn" :disabled="isDisabled('FIRST')" @click.prevent="first"><i
                        class="fas fa-angle-double-left"></i></button>
                  <button type="button" class="page-btn" :disabled="isDisabled('FIRST')" @click.prevent="previous">
                     <i class="fas fa-angle-left"></i>
                  </button>

                  Page {{ currentPage + 1 }} of {{ totalPages }}

                  <button type="button" class="page-btn" :disabled="isDisabled('LAST')" @click.prevent="next">
                     <i class="fas fa-angle-right"></i>
                  </button>
                  <button type="button" class="page-btn" :disabled="isDisabled('LAST')" @click.prevent="last">
                     <i class="fas fa-angle-double-right"></i>
                  </button>
                  &nbsp;
                  Total Records: {{ totalRecords }}
               </div>
            </td>
         </tfoot>
      </table>
   </div>
</template>

<script>


export default {
   name: 'DataGrid',
   data() {
      return {
         recordsPerPage: this.rowsPerPage
      }
   },
   props: ['headers', 'records', 'rowsPerPage', 'currentPage', 'totalRecords', 
      'clickHandler', 'navHandler', 'noDataMsg', 'clickHierarchy', 'hideFooter'],
   computed: {
      totalPages() {
         return this.hasData ? Math.trunc(this.totalRecords / this.rowsPerPage) + (this.totalRecords % this.rowsPerPage > 0 ? 1 : 0) : 0
      },
      showFooter() {
         if (!this.hideFooter || this.hideFooter == false)
            return true 
         return false
      }
   },
   methods: {
      pageSizeChanged() {
         this.$emit('page-size-changed', this.recordsPerPage)
      },
      hasData() {
         if (this.records != null) {
            return this.records.length > 0
         }
         return false
      },
      isDisabled(btn) {
         if (btn == 'FIRST' && this.currentPage == 0) return true
         if (btn == 'LAST' && this.currentPage == this.totalPages - 1) return true
         if (btn=='LAST' && this.totalRecords == 0) return true  
         return false
      },
      toolTipText(col) {
         if (!col.tt) return ''
         return col.tt
      },
      first() {
         this.navHandler('FIRST')
      },
      last() {
         this.navHandler('LAST')
      },
      next() {
         this.navHandler('NEXT')
      },
      previous() {
         this.navHandler('PREVIOUS')
      }
   }
}
</script>

<style scoped lang="scss">
@import '../assets/css/colors.scss';

table {
   font-size: smaller;
}

tfoot {
   font-size: smaller;
   line-height: 25px;
   color: $corp-color;
}

.page-btn {
   width: 36px;
   height: 27px;
   border: 1px solid #ccc;
   cursor: pointer;
   text-align: center;
   margin-top: 4px;
   color: #000;
   background-color: #fff;
   outline: none;
}

.page-btn i {
   margin-right: 0;
}

.page-btn:focus {
   outline: none;
}

.page-btn:disabled {
   color: #ccc;
   background-color: #eee;
}

.rpp-btn {
   height: 27px;
}

.not-found {
   font-style: italic;
   color: #CC0000;
}</style>